import { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { ROUTE_PATHS } from 'src/shared/config/routes';

// https://github.com/cavela-co/cavela/pull/4566
// redirect to product detail page that uses query params instead of path params
// this is due to how we changed the implementation of urls in the PR above

const ProductDetailUrlRedirect = () => {
  const [searchParams] = useSearchParams();
  const { id, tab } = useParams<{ id: string; tab: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id || !tab) {
      navigate(ROUTE_PATHS.PRODUCTS);

      return;
    }

    // if more search params are provided, add them to the url
    if (searchParams.size > 0) {
      const searchParamsString = searchParams.toString();

      navigate(
        `${ROUTE_PATHS.PRODUCTS}/${id}?tab=${tab}&${searchParamsString}`
      );
    } else {
      navigate(`${ROUTE_PATHS.PRODUCTS}/${id}?tab=${tab}`);
    }
  }, [id, navigate, tab, searchParams]);

  return null;
};

export default ProductDetailUrlRedirect;
